import { useState, useContext } from 'react'
import { connect } from 'react-redux'
import { NavLink as Link, useNavigate } from 'react-router-dom'

import { signup } from 'api'
import { setCurrentUser } from 'store/actions'
import { MessageContext } from 'App'

import styled from 'styled-components'

const Container = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  height: 80vh;

  .Wrapper {
    width: 320px;
  }

  .Logo {
    text-align: center;
    font-size: 64px;
    font-family: sans-serif;
    margin-bottom: 32px;
  }

  .Form {
    flex-direction: column;
    gap: 16px;
    display: flex;
    text-align: center;

    input {
      font-size: 18px;
      padding: 8px;
      text-align: center;
    }

    button {
      font-size: 18px;
      padding: 8px;
      cursor: pointer;
      background-color: #6f6;

      &:hover {
        background-color: #2e2;
      }
    }
  }
`

const SignupPage = ({ setCurrentUser }) => {
  const navigate = useNavigate()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [passwordConfirmation, setPasswordConfirmation] = useState('')

  const { showSuccess, showError } = useContext(MessageContext)

  const onSubmit = () => {
    signup({
      user: {
        email, password, passwordConfirmation
      }
    }).then(({ data, message, errors }) => {
      if (errors) {
        errors.forEach(({ message }) => {
          showError(message)
        })
      } else {
        setCurrentUser(data.user)

        showSuccess(message)

        navigate('/')
      }
    }).catch(() => {
      showError()
    })
  }

  return (
    <Container>
      <div className='Wrapper'>
        <div className='Logo'>
          DREVA
        </div>
        <div className='Form'>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder='email'
            type='email'
          />
          <input
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder='новы пароль'
            type='password'
          />
          <input
            value={passwordConfirmation}
            onChange={(e) => setPasswordConfirmation(e.target.value)}
            placeholder='яшчэ раз гэты пароль'
            type='password'
          />
          <button onClick={onSubmit}>Зарэгістравацца</button>
          <div>або</div>
          <Link to='/login'>Увайсьці</Link>
        </div>
      </div>
    </Container>
  )
}

export default connect(
  (state) => ({
    currentUser: state.main.currentUser,
  }),
  (dispatch) => ({
    setCurrentUser: (currentUser) => dispatch(setCurrentUser(currentUser)),
  })
)(SignupPage)
